import { SUMMARIES as summaries } from './summaries';
import { WELCOME_MODAL as welcome_modal } from './welcomeModal';
import { WIDGETS as widgets } from './widgets';

export const DASHBOARD = {
  summaries,
  welcome_modal,
  widgets
};
